import { Response } from "@/api/client";
import { useSnackbarStore } from "@/store/snackbar.store";
import { usePipStore } from "@/store/pip.store";

export function useError() {
  function showAPIError(response: Response<any>, defaultMessage = "") {
    const { showSnackbarError } = useSnackbarStore();

    let message = defaultMessage;
    const detail = response.errorData?.detail;

    if (Array.isArray(detail) && detail.length > 0) {
      message = detail[0]?.msg ?? defaultMessage;
    } else if (typeof detail === "string") {
      message = detail;
    }

    showSnackbarError(message);
  }

  function scrollToError(container?: ParentNode | null) {
    const pipStore = usePipStore();
    const roots = [container, pipStore.pipContainer, document].filter((root): root is ParentNode => Boolean(root));

    for (const root of roots) {
      const element = root.querySelector(".v-field--error:first-of-type");

      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });

        return;
      }
    }
  }

  return {
    showAPIError,
    scrollToError,
  };
}
